const ActivityScopeEnum = Object.freeze({
    GLOBAL: 'GLOBAL',
    TASK: 'TASK',
    USER: 'USER',
    LOCAL: 'LOCAL'
});

export default ActivityScopeEnum;
